/**
 * @generated SignedSource<<71e517f215bbd13011c09859b407acbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MyPageSettingMutation$variables = {
  allowNotification?: boolean | null;
};
export type MyPageSettingMutation$data = {
  readonly updateInfluencer: {
    readonly __typename: "Influencer";
    readonly allowNotification: boolean;
  } | {
    readonly __typename: "UpdateInfluencerError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type MyPageSettingMutation = {
  response: MyPageSettingMutation$data;
  variables: MyPageSettingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "allowNotification"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "allowNotification",
        "variableName": "allowNotification"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowNotification",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyPageSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyPageSettingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0badfdddaf7cd42a459b618191a53550",
    "id": null,
    "metadata": {},
    "name": "MyPageSettingMutation",
    "operationKind": "mutation",
    "text": "mutation MyPageSettingMutation(\n  $allowNotification: Boolean\n) {\n  updateInfluencer(input: {allowNotification: $allowNotification}) {\n    __typename\n    ... on Influencer {\n      allowNotification\n      id\n    }\n    ... on UpdateInfluencerError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a80e1425836ada812f06769092472cca";

export default node;
